import React from "react";
import styles from "./styles.css";
import CarFinanceImage from "./images/car-financing.png";
import PropTypes from "prop-types";

const CarFinanceCdpBannerRevamp = ({handlePreApproval}) => {
    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.leftWrapper"}>
                <p styleName={"styles.heading"}>Car financing</p>
                <p styleName={"styles.subHeading"}>Car loan eligibility in 2 mins.</p>
                <button onClick={handlePreApproval}>Get Pre-approval</button>
            </div>
            <div styleName={"styles.rightWrapper"}>
                <img src={CarFinanceImage} alt="Car financing banner image" />
            </div>
        </div>
    );
};

CarFinanceCdpBannerRevamp.propTypes = {
    handlePreApproval: PropTypes.func
};

export default CarFinanceCdpBannerRevamp;
